<template>
  <div class="flex flex-col rounded-lg shadow">
    <img :src="image" class="w-full h-48 rounded-lg object-cover"/>
    <div class="p-2 h-full flex flex-col justify-between">
      <div class="">
        <div>
          App Názov: {{ props.product.title }}
        </div>
        <div>
          App Text : {{ props.product.text }}
        </div>
        <template v-if="props.product.pluItem">

          <div>
            Plu názov : {{ props.product.pluItem.pluName }}
          </div>

          <div>
            Plu id : {{ props.product.pluItem.pluId }}
          </div>

          <div>
            Plu cena : {{ props.product.pluItem.pluPrice }}
          </div>

        </template>

        <hr class="my-2">
      </div>

      <div class="flex  justify-end">
        <Button @click="editProduct" label="Upraviť" size="small" class=""/>
      </div>

    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue'
import {IMG_URL} from "@/content/lists.js";

const props = defineProps({
  product: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['edit-product'])

const image = computed(() => props.product?.images?.length ? `${IMG_URL}/public/app-products-images/${props.product?.images[0]}` : 'https://placehold.co/400')

const editProduct = () => {
  const product = {...props.product}
  try {
    product['pluItemId'] = product['pluItem']['id'] ?? null
    delete product['pluItem']
  } catch (e) {

  }
  emit('edit-product', product)
}

</script>